import { PersonInfo, Pronoun, ROLE } from '../../consts';
import image from './robert-honsby.jpg';

export const RobertHonsby: PersonInfo = {
  firstName: 'Rob',
  lastName: 'Honsby',
  image,
  pronoun: Pronoun.HE,
  role: ROLE.SOFTWARE_ENGINEER,
};
